import React from 'react'
import get from 'lodash/get'
import { motion } from 'framer-motion'
import { useStaticQuery, graphql } from 'gatsby'

import { Link } from '@elements'
import { useHover } from '@hooks'
import { htmlDecode } from '@utils'

export const DesktopNavigation = () => {
  const data = useStaticQuery(graphql`
    query {
      ...MainNav
      site {
        siteMetadata {
          API_URL
        }
      }
    }
  `)

  // safely get the main menu or an empty array
  const mainMenu = get(data, 'mainNav.menuItems.edges', []).filter(
    ({ node }) => !node.parentId
  )
  const API_URL = get(data, 'site.siteMetadata.API_URL', [])

  return (
    <nav className="relative z-40 items-center hidden text-lg font-bold lg:flex">
      {mainMenu.map(({ node }, idx) => {
        return (
          <MenuItem
            key={node.id}
            node={node}
            isLastMenuItem={mainMenu.length === idx + 1}
            API_URL={API_URL}
          />
        )
      })}
    </nav>
  )
}

function MenuItem({ node, isLastMenuItem, API_URL }) {
  const [isHovered, bind] = useHover()

  const variants = {
    hidden: { opacity: 0, height: `0` },
    visible: { opacity: 1, height: `auto` },
  }

  return (
    <div className="relative inline" {...bind}>
      <Link
        to={`${node.url.replace(API_URL, '')}`}
        // add different classes for last item
        activeClassName="pb-1 border-box border-b-4 border-gray-400"
        partiallyActive
        className={`
      
        ${
          isLastMenuItem
            ? `inline-block px-10 pt-1 mr-4 font-sans text-2xl font-bold text-gray-400 no-underline uppercase transition duration-200 border-6 border-brand-yellow hover:bg-brand-yellow`
            : `relative mr-6 xl:mr-10 text-gray-400 no-underline uppercase xl:mr-16 border-b-4 border-transparent hover:border-gray-400 no-wrap transition duration-150`
        }`}
      >
        {htmlDecode(node.label)}
      </Link>

      {node.childItems &&
        node.childItems.edges &&
        node.childItems.edges.length > 1 && (
          <motion.ul
            className={`bg-white absolute flex flex-col shadow px-8 py-3 divide-y divide-gray-100 overflow-hidden z-50 ${
              isHovered ? '' : 'hidden'
            }`}
            initial="hidden"
            animate={`${isHovered ? 'visible' : 'hidden'}`}
            variants={variants}
            style={{
              top: 30,
              left: 0,
              width: 'auto',
            }}
          >
            {node.childItems.edges.map(({ node }) => {
              return (
                <li key={node.id} className="relative py-3">
                  <Link
                    className={`relative flex items-center whitespace-no-wrap text-lg mr-10 text-gray-400 no-underline leading-tight uppercase xl:mr-16 hover:border-b-4 hover:border-gray-400`}
                    to={`${node.url.replace(API_URL, '')}`}
                  >
                    {htmlDecode(node.label)}
                  </Link>
                </li>
              )
            })}
          </motion.ul>
        )}
    </div>
  )
}
